// Every value is supplied by the build environment. Vite inlines
// `import.meta.env.VITE_*` at build time, so all of it ends up readable in the
// shipped bundle - none of it is a secret from the browser's point of view.
// CI sets these per environment; `npm run dev` reads ui/.env.development.
//
// This replaces the old config-sbx / config-prod file swap, where the deploy
// copied one tracked file over another. That put the deployed API key in the
// repo and made "which config is checked in right now" a live question.

const required = (value: string | undefined, name: string): string => {
  if (!value) {
    throw new Error(
      `${name} is not set. The UI cannot be built without it - see ui/.env.development.`
    );
  }
  return value;
};

export const apiEndpoint = required(
  import.meta.env.VITE_API_ENDPOINT,
  "VITE_API_ENDPOINT"
);

/*
 * Everything Auth0 needed is gone - `patreon-direct-auth` task 9.
 *
 * `VITE_AUTH0_DOMAIN`, `_CLIENT_ID`, `_CONNECTION` and `_AUDIENCE` were all
 * inlined into the shipped bundle by Vite. None of them was secret, but all
 * four were configuration this app had to keep in step with a dashboard
 * somebody edits by hand. The client id, the connection name and the scopes
 * now live on the server, where the Patreon exchange happens, so the browser
 * knows nothing about the identity provider beyond the URL of our own
 * `/auth/start`.
 *
 * The `authorizationParams` block that stood here carried a long note about
 * requesting the audience at login so Auth0 would not need a hidden iframe
 * against the tenant domain - an iframe Chrome blocks because it needs a
 * third-party cookie. That whole class of problem is gone with it: there is no
 * cross-site iframe in this design and no token for the browser to renew.
 */

// No API key. The REST API's usage plan is gone (D-35): a key compiled into
// the shipped bundle identified nobody and refused nobody, and throttling now
// sits on the stage where it needs no caller identity at all.
